import CssBaseline from '@mui/material/CssBaseline';
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import React from 'react';
import 'react-awesome-slider/dist/styles.css';
import { ThemeProvider } from 'styled-components';
import { useTheme } from 'theme.hooks';

const Theme = ({ children }) => {
  const { theme } = useTheme();

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {children}
        </ThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default Theme;
